import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import { type ProfileBillingViewModel } from '@/features/iam/users/ProfileBillingViewModel'
import { PayoutMethodSection } from '@/features/iam/users/Profile/Billing'
import { ProfilePayoutMethodContainer } from '@/features/payouts/pro/components/ProfilePayoutMethod/ProfilePayoutMethodContainer'

export default observer(function BillingPayoutMethodContainer() {
  const billing = useOutletContext<ProfileBillingViewModel>()
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <PayoutMethodSection corporateMode={shellInfo.corporateMode}>
      <ProfilePayoutMethodContainer vm={billing.payoutMethodVm} />
    </PayoutMethodSection>
  )
})
